import { useState, useRef, FC, ChangeEvent, useEffect } from 'react';
import styles from "./BusinessNameField.module.scss";
import editIcon from "./icons/edit.png";

interface IBusinessNameFieldProps {
    name: string;
    onChangeNameHandler: (newName: string) => void;
}

export const BusinessNameField: FC<IBusinessNameFieldProps> = ({ name, onChangeNameHandler }) => {
    const [value, setValue] = useState<string | undefined>();
    const [isEditing, setIsEditing] = useState(false);

    const inputRef = useRef<HTMLInputElement  | null>(null);

    useEffect(() => {
        setValue(name);
    }, [name]);

    const handleIconClick = () => {
        setIsEditing(true);
        if (inputRef.current)
            inputRef.current.focus();
    };

    const onBlurHandler = () => {
        setIsEditing(false);

        if (value === '') {
            setValue(name);
            return;
        }

        if (value)
            onChangeNameHandler(value);
    }

    const onChangeValueHandler = (event: ChangeEvent<HTMLInputElement>) => {
        const sanitizedName = event.target.value
            .replace(/[^a-zA-Zа-яА-Я0-9-\s]/g, '')
            .slice(0, 24);

        setValue(sanitizedName);
    };

    return (
        <div className={styles.businessNameWrapper}>
            { isEditing
                ? <input
                    className={styles.businessNameInput}
                    ref={inputRef}
                    type="text"
                    value={value}
                    onChange={ onChangeValueHandler }
                    onBlur={ onBlurHandler }
                    autoFocus                    
                />
                : <span className={styles.businessName}>{ value }</span> }

            { !isEditing && <img
                src={editIcon}
                alt="Редактировать"
                className={styles.editIcon}
                onClick={handleIconClick}
            /> }
        </div>
    );
};